import { FC } from "react";
import { getNetworkIcon } from "./ supported-networks-config";
import styles from "./ supported-networks-icons.module.scss";

export interface NetworkIconsProps {
  networks: { name: string }[];
}

const NetworkIcons: FC<NetworkIconsProps> = ({ networks }) => {
  return (
    <div className={styles.container}>
      {networks &&
        networks.length > 0 &&
        networks.map((network) => {
          const IconComponent = getNetworkIcon(network.name);
          return IconComponent ? <IconComponent key={network.name} /> : null;
        })}
    </div>
  );
};

export default NetworkIcons;
